<div class="charts" data-testid="node-charts">
    <!-- what to chart: an attribute for a bar chart, or three (across, up, size) for a bubble chart -->
    <div class="chart-controls">
        @for (fieldType of fieldTypes; track $index; let i = $index) {
            <mat-form-field class="field" subscriptSizing="dynamic">
                <mat-label>{{getLabel(i)}}</mat-label>
                <mat-select (valueChange)="selectField($event)" [(ngModel)]="fieldType.type" [placeholder]="'Choose an attribute'">
                    @for (field of getChartFields(); track field) {
                        <mat-option [value]="field">{{field}}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        @if (chartType !== CHART_TYPE.BUBBLE) {
            <mat-form-field class="top" subscriptSizing="dynamic">
                <mat-label>Show top</mat-label>
                <input matInput type="number" min="1" [(ngModel)]="topNumber" placeholder="35">
            </mat-form-field>
        }
        @if (chartType === CHART_TYPE.BAR) {
            <mat-slide-toggle [(ngModel)]="hideZeros">Hide zero values</mat-slide-toggle>
        }
    </div>

    <section class="chart-card" [attr.aria-label]="title()">
        @if (isValid()) {
            <header class="chart-head">
                <h3>{{title()}}</h3>
                <p>{{subtitle()}}</p>
            </header>
            @if (chartType === CHART_TYPE.HEATMAP) {
                <app-node-heatmap-chart [linqset]="linqset" [trigger]="childTrigger" [typeData]="selectedTypeData" [fieldType]="fieldTypes[0]" [topNumber]="topNumber" (selectNodeEvent)="selectNodeForKey($event)"></app-node-heatmap-chart>
            }@else if (chartType === CHART_TYPE.COMPARE) {
                <app-node-compare-chart [linqset]="linqset" [comparison]="comparison" [trigger]="childTrigger" [typeData]="selectedTypeData" [fieldType]="fieldTypes[0]" [topNumber]="topNumber" (selectNodeEvent)="selectNodeForKey($event)"></app-node-compare-chart>
            }@else if (chartType === CHART_TYPE.CAPACITY) {
                <app-node-capacity-chart [linqset]="linqset" [trigger]="childTrigger" [typeData]="selectedTypeData" [topNumber]="topNumber" (selectNodeEvent)="selectNodeForKey($event)"></app-node-capacity-chart>
            }@else if (chartType === CHART_TYPE.PARETO) {
                <app-node-pareto-chart [linqset]="linqset" [trigger]="childTrigger" [typeData]="selectedTypeData" [fieldType]="fieldTypes[0]" [topNumber]="topNumber" (selectNodeEvent)="selectNodeForKey($event)"></app-node-pareto-chart>
            }@else if (chartType === CHART_TYPE.BUBBLE) {
                <app-node-bubble-chart [linqset]="linqset" [trigger]="childTrigger" [fieldTypes]="fieldTypes" [typeData]="selectedTypeData" (selectNodeEvent)="selectNodeForKey($event)"></app-node-bubble-chart>
            }@else {
                <app-node-bar-chart [linqset]="linqset" [comparison]="comparison" [trigger]="childTrigger" [fieldType]="fieldTypes[0]" [hideZeros]="hideZeros" [typeData]="selectedTypeData" [topNumber]="topNumber" (selectNodeEvent)="selectNodeForKey($event)"></app-node-bar-chart>
            }
        }@else {
            <div class="chart-empty">
                <mat-icon>{{chartType === CHART_TYPE.BUBBLE ? 'bubble_chart' : 'bar_chart'}}</mat-icon>
                <p>{{chartType === CHART_TYPE.BUBBLE ? 'Choose what goes across, up and the bubble size to chart the ' + typeName() + ' nodes.' : 'Choose an attribute to chart the ' + typeName() + ' nodes.'}}</p>
            </div>
        }
    </section>
</div>
